import { motion } from "motion/react";

import { useWebsiteParameter } from "@contexts/WebsiteContext";
import cn from "@utils/helpers/cn";

const PageHeaderContent = (props) => {
  const { value } = props;

  if (!value.includes("&")) return value;

  const [name1, name2] = value.split("&");

  return (
    <>
      {name1}
      <span className="mx-[0.1rem] text-[color:var(--page-header-ampersand-color)]">
        &
      </span>
      {name2}
    </>
  );
};

export default function PageHeader(props) {
  const { value } = props;

  const defaultPageHeader = useWebsiteParameter("pageHeader");
  const displayValue = value || defaultPageHeader;

  const headerClassNames = cn(`
    rounded-2xl
    border-[0.0625rem]
    border-solid
    border-page-header-border
    bg-page-header-bg
    px-3
    py-1
    text-[0.75rem]
    font-normal
    uppercase
    leading-normal
    tracking-[0.05rem]
    text-page-header-text
    shadow-md
  `);

  /**************************************************************************************************/

  if (!displayValue) return null;

  return (
    <motion.div
      key="page-header"
      className="flex justify-center"
      initial={{
        opacity: 0,
        y: "-1rem",
      }}
      animate={{
        opacity: 1,
        y: "0",
      }}
      transition={{
        delay: 0.5,
        type: "spring",
        stiffness: 100,
        damping: 10,
      }}
      layout={true}
    >
      <motion.span className={headerClassNames}>
        <PageHeaderContent value={displayValue} />
      </motion.span>
    </motion.div>
  );
}
